import { Check } from "lucide-react";
import type { InputHTMLAttributes, ReactNode } from "react";
import { useId } from "react";

interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  label?: ReactNode;
  error?: string;
  helper?: string;
}

export default function Checkbox({ label, error, helper, id, className = "", ...rest }: CheckboxProps) {
  const autoId = useId();
  const boxId = id ?? autoId;

  return (
    <div className={className}>
      <label htmlFor={boxId} className="inline-flex cursor-pointer items-center gap-2.5">
        <span className="relative flex h-5 w-5 items-center justify-center">
          <input
            id={boxId}
            type="checkbox"
            className="peer h-5 w-5 appearance-none rounded border border-slate-300 bg-white transition-colors checked:border-primary-500 checked:bg-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-500/30 cursor-pointer"
            {...rest}
          />
          <Check className="pointer-events-none absolute h-3.5 w-3.5 text-white opacity-0 transition-opacity peer-checked:opacity-100" strokeWidth={3} />
        </span>
        {label && <span className="text-sm text-ink">{label}</span>}
      </label>
      {error ? (
        <p className="mt-1 text-xs text-danger">{error}</p>
      ) : helper ? (
        <p className="mt-1 text-xs text-ink-muted">{helper}</p>
      ) : null}
    </div>
  );
}